import { EVALUATION_STATUS } from 'sharedKernel/constants'
import { hasTextMatch } from 'sharedKernel/handlers'
import { EVALUATORS_SHOWN_LIST } from '.'
import { ISolution } from '../contracts'

export const sortRows = (solutionsRows: any[], finalScoreAsc: boolean, solutionTitleAsc: boolean, finalScoreClick: boolean, solutionTitleClick: boolean): any[] => {
  if (finalScoreClick) {
    if (finalScoreAsc) {
      solutionsRows.sort((a, b) => {
        const scoreA = a?.progress?.points || a?.evaluation?.averageScore || a?.averageScore || 0
        const scoreB = b?.progress?.points || b?.evaluation?.averageScore || b?.averageScore || 0
        return scoreB - scoreA
      })
    } else {
      solutionsRows.sort((a, b) => {
        const scoreA = a?.progress?.points || a?.evaluation?.averageScore || a?.averageScore || 0
        const scoreB = b?.progress?.points || b?.evaluation?.averageScore || b?.averageScore || 0
        return scoreA - scoreB
      })
    }
  }
  if (solutionTitleClick) {
    if (solutionTitleAsc) {
      solutionsRows.sort((a, b) => {
        const x = (a?.idea?.name || a?.title || a?.ideaTitle || '').toLowerCase()
        const y = (b?.idea?.name || b?.title || b?.ideaTitle || '').toLowerCase()
        if (x < y) {
          return 1
        } else {
          return -1
        }
      })
    } else {
      solutionsRows.sort((a, b) => {
        const x = (a?.idea?.name || a?.title || a?.ideaTitle || '').toLowerCase()
        const y = (b?.idea?.name || b?.title || b?.ideaTitle || '').toLowerCase()
        if (x < y) {
          return -1
        } else {
          return 1
        }
      })
    }
  }
  return solutionsRows
}

export const filterByTabValue = (solution: any, tabStatus: string): boolean => {
  if (tabStatus === '') {
    return true
  }

  let statusName = solution.status?.name || solution.status || 'CREATED'
  
  if (statusName === 'Created') statusName = 'CREATED'
  if (statusName === 'Approved') statusName = 'APPROVED'
  if (statusName === 'Disapproved') statusName = 'DISAPPROVED'
  if (statusName === 'Launched') statusName = 'LAUNCHED'
  
  return statusName === tabStatus
}

export const filterValueMatchAnyField = (solution: any, filterValue: string, columnMasks: any): boolean => {
  if (filterValue === '') {
    return true
  }

  const title = solution.idea?.name || solution.title || solution.ideaTitle || ''
  if (hasTextMatch(title, filterValue)) {
    return true
  }

  const averageScore = solution.progress?.points || solution.evaluation?.averageScore || solution.averageScore
  if (hasTextMatch(averageScore, filterValue)) {
    return true
  }

  const standardDeviation = solution.evaluation?.standardDeviation || solution.standardDeviation
  if (hasTextMatch(standardDeviation, filterValue)) {
    return true
  }

  if (checkMatchEvaluationPoints(solution, filterValue, columnMasks)) {
    return true
  }

  if (solution.evaluatorsWhoEvaluated?.some((evaluator: string) => hasTextMatch(evaluator, filterValue))) {
    return true
  }

  return false
}

const checkMatchEvaluationPoints = (solution: any, filterValue: string, columnMasks: any): boolean => {
  const evaluations = solution.evaluation?.evaluations || solution.evaluations || []
  
  for (let index = 0; index < EVALUATORS_SHOWN_LIST; index++) {
    if (index >= evaluations.length) {
      break
    }

    if (evaluations[index].status === EVALUATION_STATUS.PENDING) {
      if (hasTextMatch(columnMasks.pendingEvaluation, filterValue)) return true
    }

    if (evaluations[index].status === EVALUATION_STATUS.NOT_ACCEPTED) {
      if (hasTextMatch(columnMasks.notAcceptedEvaluation, filterValue)) return true
    }

    if (hasTextMatch(evaluations[index].points, filterValue)) {
      return true
    }
  }

  return false
}
